import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRotateRight = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 14,
	viewBox: "0 0 15 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M13.625 0.03125C14.0625 0.03125 14.5 0.34375 14.5 0.875V5.4375C14.5 5.75 14.2188 6.03125 13.875 6.03125H9.34375C8.8125 6.03125 8.5 5.59375 8.5 5.1875C8.5 4.96875 8.5625 4.75 8.75 4.59375L10.1562 3.15625C9.28125 2.4375 8.15625 2.03125 6.96875 2.03125C4.21875 2.03125 2 4.28125 2 7.03125C2 9.78125 4.21875 12 6.96875 12C9.28125 12 9.78125 10.8125 10.5938 10.8125C11.1562 10.8125 11.5625 11.2812 11.5625 11.8125C11.5625 12.9062 9.03125 14 6.96875 14C3.125 14 0 10.875 0 7.03125C0 3.15625 3.125 0.03125 7 0.03125C8.6875 0.03125 10.3125 0.65625 11.5625 1.75L13.0625 0.28125C13.2188 0.09375 13.4375 0.03125 13.625 0.03125Z",
		fill: "#607D8B"
	})]
});
const ForwardRef = forwardRef(SvgRotateRight);
export { ForwardRef as ReactComponent };
